import _isEmpty from 'lodash/isEmpty';
import * as types from '../constants/ActionTypes';
import { trackPage } from '../../lib/analytics-helper';

export const contactRequestByEmail = (formFields) => {
  if (_isEmpty(formFields)) {
    return {
      type: types.RECEIVE_EMPTY_FIELDS,
    };
  }

  trackPage({ id: 'emailPage', link: 'smarthelp-email-us' });
  return {
    type: types.REQUEST_BY_EMAIL,
  };
};

export const contactByEmail = responseData => (dispatch) => {
  dispatch(contactRequestByEmail(responseData));
};

export const contactRequestByEmailNoIntent = (formFields) => {
  if (_isEmpty(formFields)) {
    return {
      type: types.RECEIVE_EMPTY_FIELDS_NO_INTENT,
    };
  }
  return {
    type: types.REQUEST_BY_EMAIL_NO_INTENT,
  };
};

export const contactByEmailNoIntent = responseData => (dispatch) => {
  dispatch(contactRequestByEmailNoIntent(responseData));
};
